import { PublicClientApplication } from "@azure/msal-browser";
import { msalConfig } from "./MsalConfig";

export const msalInstance = new PublicClientApplication(msalConfig);
